import { render } from "./PrintInvitationSchoolAi.vue?vue&type=template&id=4cbbb59c&scoped=true&ts=true"
import script from "./PrintInvitationSchoolAi.vue?vue&type=script&lang=ts"
export * from "./PrintInvitationSchoolAi.vue?vue&type=script&lang=ts"

import "./PrintInvitationSchoolAi.vue?vue&type=style&index=0&id=4cbbb59c&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/mingaku/mingaku/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cbbb59c"]])

export default __exports__